import {
  ORGANIZATION_FETCH,
  ORGANIZATION_FETCH_SUCCESS,
  ORGANIZATION_FETCH_FAIL,
  ORGANIZATION_SAVE,
  ORGANIZATION_SAVE_SUCCESS,
  ORGANIZATION_SAVE_FAIL
} from '../constants/ActionTypes';

export function organizationFetch(organizationID) {
  return {
    type: ORGANIZATION_FETCH,
    organizationID
  };
}

export function organizationFetchSuccess(organization) {
  return {
    type: ORGANIZATION_FETCH_SUCCESS,
    organization
  };
}

export function organizationFetchFail(error) {
  return {
    type: ORGANIZATION_FETCH_FAIL,
    error
  };
}

export function organizationSave(organizationID, data, translation) {
  return {
    type: ORGANIZATION_SAVE,
    organizationID,
    data,
    translation
  }
}

export function organizationSaveSuccess(payload) {
  return {
    type: ORGANIZATION_SAVE_SUCCESS,
    payload
  }
}

export function organizationSaveFail(payload) {
  return {
    type: ORGANIZATION_SAVE_FAIL,
    payload
  }
}

